export enum Params {
  UTM_SOURCE = 'utm_source',
  UTM_MEDIUM = 'utm_medium',
  UTM_CAMPAIGN = 'utm_campaign',
  tenantGUID = 'tenantGUID',
  Type = 'type'
}
